export const programClassifications = [
  'recipe',
  'cip',
  'sip',
  'downtime',
  'maintenance',
  'setup',
  'unplanned_downtime',
  'unassigned',
] as const
